<template>
  <div>
    <div class="mb-5">
      <h1 class="is-size-4">Passengers</h1>

      <div class="passenger is-size-6 mb-1 p-3" style="border:1px solid #ccc" v-for="passenger in passengers" :key="passenger.id">
        {{ passenger.name }}
      </div>
    </div>
    
  </div>
</template>

<script>
//import Seat from './Seat.vue'
export default {
  components: {
    //Seat
  },
  methods: {
  },
  props: {
    passengers: Array,
  }
}

</script>

<style scoped>


</style>
